import React, { useState } from "react";
import { colors, spacing, borderRadius } from "../styles/globalStyles";

const DemoModal = ({ isOpen, onClose }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const demoSlides = [
    {
      id: "scan-qr",
      title: "1. Someone Scans Your QR Code",
      description: "A bystander, paramedic, or doctor points their phone camera at your QR sticker or locket. That's all it takes.",
      content: (
        <div style={{ textAlign: "center", padding: spacing.xl }}>
          <div
            style={{
              width: "200px",
              height: "200px",
              margin: "0 auto",
              backgroundColor: "#000000",
              borderRadius: borderRadius.lg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              border: "4px solid #ffffff",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
          >
            <div
              style={{
                width: "90%",
                height: "90%",
                display: "grid",
                gridTemplateColumns: "repeat(8, 1fr)",
                gridTemplateRows: "repeat(8, 1fr)",
                gap: "2px",
              }}
            >
              {Array.from({ length: 64 }).map((_, i) => (
                <div
                  key={i}
                  style={{
                    backgroundColor: Math.random() > 0.5 ? "#FFFFFF" : "#000000",
                  }}
                />
              ))}
            </div>
            <div
              style={{
                position: "absolute",
                top: "-10px",
                left: "-10px",
                right: "-10px",
                bottom: "-10px",
                border: "2px dashed #3B82F6",
                borderRadius: borderRadius.lg,
                animation: "pulse 2s infinite",
              }}
            />
          </div>
          <div style={{ marginTop: spacing.lg, fontSize: "18px", fontWeight: "600", color: colors.gray[800] }}>
            📱 Just point and scan
          </div>
          <div style={{ marginTop: spacing.sm, color: colors.gray[600] }}>Your emergency details open instantly in their browser</div>
        </div>
      ),
      bgColor: "from-blue-50 to-cyan-100",
    },
    {
      id: "public-info",
      title: "2. They See Your Medical Details",
      description: "Blood type, allergies, medications, and emergency contacts — everything they need, right on their screen.",
      content: (
        <div style={{ padding: spacing.xl }}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: borderRadius.lg,
              padding: spacing.lg,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
            }}
          >
            <div style={{ fontSize: "24px", fontWeight: "700", color: colors.gray[900], marginBottom: spacing.md }}>
              🏥 Medical Information
            </div>
            <div style={{ marginBottom: spacing.md }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: spacing.sm,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.sm,
                  marginBottom: spacing.xs,
                }}
              >
                <span style={{ fontWeight: "600", color: colors.gray[700] }}>Blood Type:</span>
                <span style={{ color: colors.gray[800] }}>O+</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: spacing.sm,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.sm,
                  marginBottom: spacing.xs,
                }}
              >
                <span style={{ fontWeight: "600", color: colors.gray[700] }}>Allergies:</span>
                <span style={{ color: colors.gray[800] }}>Peanuts, Shellfish</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: spacing.sm,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.sm,
                }}
              >
                <span style={{ fontWeight: "600", color: colors.gray[700] }}>Medications:</span>
                <span style={{ color: colors.gray[800] }}>Aspirin 100mg</span>
              </div>
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "700",
                color: colors.gray[900],
                marginTop: spacing.lg,
                marginBottom: spacing.md,
              }}
            >
              📞 Emergency Contacts
            </div>
            <div style={{ padding: spacing.sm, backgroundColor: colors.gray[50], borderRadius: borderRadius.sm }}>
              <div style={{ fontWeight: "600", color: colors.gray[700] }}>Dr. John Smith</div>
              <div style={{ color: colors.gray[600], fontSize: "14px" }}>+91 98765 43210</div>
            </div>
          </div>
          <div style={{ marginTop: spacing.md, textAlign: "center", color: colors.gray[600], fontSize: "14px" }}>
            No login needed — the person helping you sees this immediately
          </div>
        </div>
      ),
      bgColor: "from-green-50 to-emerald-100",
    },
    {
      id: "owner-login",
      title: "3. Only You Can Edit Your Info",
      description: "Log in with your password to update your details anytime. Nobody else can change what you've saved.",
      content: (
        <div style={{ padding: spacing.xl }}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: borderRadius.lg,
              padding: spacing.xl,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
              maxWidth: "400px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: colors.gray[900],
                marginBottom: spacing.lg,
                textAlign: "center",
              }}
            >
              🔐 Owner Login
            </div>
            <div style={{ marginBottom: spacing.md }}>
              <div style={{ fontSize: "14px", fontWeight: "600", color: colors.gray[700], marginBottom: spacing.xs }}>
                Locket ID
              </div>
              <div
                style={{
                  padding: spacing.sm,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.sm,
                  border: "1px solid #e5e7eb",
                  fontFamily: "monospace",
                  fontWeight: "600",
                }}
              >
                ABC123XY
              </div>
            </div>
            <div style={{ marginBottom: spacing.md }}>
              <div style={{ fontSize: "14px", fontWeight: "600", color: colors.gray[700], marginBottom: spacing.xs }}>
                Password
              </div>
              <div
                style={{
                  padding: spacing.sm,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.sm,
                  border: "1px solid #e5e7eb",
                }}
              >
                ••••••••
              </div>
            </div>
            <button
              style={{
                width: "100%",
                padding: spacing.md,
                backgroundColor: colors.primary,
                color: "#ffffff",
                borderRadius: borderRadius.md,
                border: "none",
                fontWeight: "600",
                fontSize: "16px",
                cursor: "pointer",
                marginTop: spacing.md,
              }}
            >
              Login
            </button>
            <div style={{ marginTop: spacing.md, textAlign: "center", color: colors.gray[600], fontSize: "14px" }}>
              Your password protects your data — only you can make changes
            </div>
          </div>
        </div>
      ),
      bgColor: "from-purple-50 to-violet-100",
    },
    {
      id: "edit-info",
      title: "4. Organize It Your Way",
      description: "Group your details into sections like Medical, Contacts, and Personal. Choose what's public and what's private.",
      content: (
        <div style={{ padding: spacing.xl }}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: borderRadius.lg,
              padding: spacing.lg,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
            }}
          >
            <div style={{ fontSize: "20px", fontWeight: "700", color: colors.gray[900], marginBottom: spacing.md }}>
              ✏️ Manage Your Information
            </div>
            <div style={{ marginBottom: spacing.md }}>
              <div
                style={{
                  padding: spacing.md,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.md,
                  marginBottom: spacing.sm,
                  border: "2px solid #3B82F6",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: spacing.xs }}
                >
                  <div style={{ fontWeight: "600", color: colors.gray[800] }}>🏥 Medical Information</div>
                  <div style={{ fontSize: "12px", color: colors.gray[600] }}>✅ Public</div>
                </div>
                <div style={{ fontSize: "14px", color: colors.gray[600] }}>Blood Type, Allergies, Medications</div>
              </div>
              <div
                style={{
                  padding: spacing.md,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.md,
                  marginBottom: spacing.sm,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: spacing.xs }}
                >
                  <div style={{ fontWeight: "600", color: colors.gray[800] }}>👤 Personal Information</div>
                  <div style={{ fontSize: "12px", color: colors.gray[600] }}>🔒 Private</div>
                </div>
                <div style={{ fontSize: "14px", color: colors.gray[600] }}>Name, Date of Birth, Address</div>
              </div>
              <div
                style={{
                  padding: spacing.md,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.md,
                  marginBottom: spacing.sm,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: spacing.xs }}
                >
                  <div style={{ fontWeight: "600", color: colors.gray[800] }}>📞 Emergency Contacts</div>
                  <div style={{ fontSize: "12px", color: colors.gray[600] }}>✅ Public</div>
                </div>
                <div style={{ fontSize: "14px", color: colors.gray[600] }}>Family, Doctor, Insurance</div>
              </div>
              <div
                style={{
                  padding: spacing.md,
                  backgroundColor: colors.gray[50],
                  borderRadius: borderRadius.md,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: spacing.xs }}
                >
                  <div style={{ fontWeight: "600", color: colors.gray[800] }}>🆔 Identification</div>
                  <div style={{ fontSize: "12px", color: colors.gray[600] }}>🔒 Private</div>
                </div>
                <div style={{ fontSize: "14px", color: colors.gray[600] }}>ID Documents, Insurance Info</div>
              </div>
            </div>
            <div style={{ textAlign: "center", color: colors.gray[600], fontSize: "14px" }}>
              Add, edit, reorder, and toggle visibility — all from your phone
            </div>
          </div>
        </div>
      ),
      bgColor: "from-orange-50 to-amber-100",
    },
  ];

  const nextSlide = () => {
    setCurrentSlideIndex((prev) => (prev + 1) % demoSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlideIndex((prev) => (prev - 1 + demoSlides.length) % demoSlides.length);
  };

  const currentSlide = demoSlides[currentSlideIndex];

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: spacing.md,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: borderRadius.xl,
          padding: 0,
          maxWidth: "900px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: spacing.lg,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <h2 style={{ fontSize: "24px", fontWeight: "700", color: colors.gray[900], margin: 0 }}>
            See How It Works
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "28px",
              cursor: "pointer",
              color: colors.gray[500],
              padding: spacing.xs,
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>

        {/* Demo Banner Carousel */}
        <div style={{ position: "relative" }}>
          <div
            className="bg-slate-50"
            style={{
              padding: spacing.xl,
              minHeight: "500px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {/* Left Navigation Button */}
            <button
              onClick={prevSlide}
              style={{
                position: "absolute",
                left: spacing.md,
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                border: "none",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                zIndex: 10,
              }}
              aria-label="Previous slide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "24px", height: "24px" }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Right Navigation Button */}
            <button
              onClick={nextSlide}
              style={{
                position: "absolute",
                right: spacing.md,
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                border: "none",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                zIndex: 10,
              }}
              aria-label="Next slide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "24px", height: "24px" }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {/* Slide Content */}
            <div style={{ textAlign: "center", marginBottom: spacing.lg }}>
              <h3 style={{ fontSize: "32px", fontWeight: "700", color: colors.gray[900], marginBottom: spacing.sm }}>
                {currentSlide.title}
              </h3>
              <p style={{ fontSize: "18px", color: colors.gray[700], marginBottom: spacing.xl }}>{currentSlide.description}</p>
            </div>

            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {currentSlide.content}
            </div>

            {/* Dots Indicator */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: spacing.sm,
                marginTop: spacing.lg,
                paddingBottom: spacing.md,
              }}
            >
              {demoSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlideIndex(index)}
                  style={{
                    width: index === currentSlideIndex ? "32px" : "12px",
                    height: "12px",
                    borderRadius: "6px",
                    border: "none",
                    backgroundColor: index === currentSlideIndex ? "#EF4444" : "rgba(255, 255, 255, 0.7)",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
